import PropTypes from 'prop-types';
import './FormLoader.scss';

const FormLoader = ({ label = 'Loading form...' }) => {
    return (
        <div className="form-loader">
            <div className="form-loader__overlay">
                <div className="form-loader__content">
                    <span className="form-loader__spinner" />
                    <p className="form-loader__label">{label}</p>
                </div>
            </div>
        </div>
    );
};

FormLoader.propTypes = {
    label: PropTypes.string
};

export default FormLoader;
